export default __webpack_public_path__ + "images/2b64ff0b15930a4ca2d06f57f5f96a98-buddhism.webp";